// Demo app: the address of the published docs site (#246). The app's own
// default links lead there (src/app/main.js), and so do the addresses the
// builds give a page with no site beside it (scripts/app-libraries.mjs).

/** The published docs site, with its trailing slash. */
export const SITE = 'https://jwildfire.github.io/safety.viz/';
